import React from "react";
import styled from "styled-components";

import CloseIcon from "../components/icons/Close";

const PopUpContainer = styled.div`
  box-sizing: border-box;
  height: 45px;
  width: 155px;
  background-color: ${props => props.theme.mapPopup};
  border-radius: 10px;
  margin-right: 10px;
  padding: 5px;
  display: flex;
  flex-direction: row-reverse;
  @media (min-width: 1300px) {
    height: 60px;
    width: 170px;
    border-radius: 10px;
    padding: 10px;
  }

  @media (min-width: 1800px) {
    height: 95px;
    width: 260px;
    border-radius: 17px;
    padding: 14px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
  font-size: 13px;
  margin-right: 20px;
  justify-content: space-evenly;
  color: ${props => props.theme.textHighlight};

  @media (min-width: 1800px) {
    font-size: 21px;
  }
`;

const BoldText = styled.span`
  font-family: "dubai-bold";
`;

const MapPopup = ({ onClose }) => {
  return (
    <PopUpContainer>
      <CloseIcon thin onClick={onClose} />
      <TextContainer>
        <BoldText>إسم المركز</BoldText>
        <span>400 خدمة حكومية</span>
      </TextContainer>
    </PopUpContainer>
  );
};

export default MapPopup;
